import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import map from "./Map";
import staticData from "./staticData";
import mapGroups from "./mapGroups";
import mapAttributes from "./mapAttributes";
import mapPatterns from "./mapPatterns";
import dialectSheetConstants from "./dialectSheetConstants";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        staticData,
        map,
        mapGroups,
        mapAttributes,
        mapPatterns,
        dialectSheetConstants,
    },
});

export default store;
